import en from './translations/en.json';
import es from './translations/es.json';

export const SUPPORTED_LANGUAGES = ['en', 'es'];
export const DEFAULT_LANGUAGE = 'en';
export const STORAGE_KEY = 'moonlight-language';

const dictionaries = { en, es };

export function detectLocale() {
  if (typeof window === 'undefined' || !window.navigator?.language) {
    return DEFAULT_LANGUAGE;
  }
  const short = window.navigator.language.slice(0, 2).toLowerCase();
  return SUPPORTED_LANGUAGES.includes(short) ? short : DEFAULT_LANGUAGE;
}

export function resolveDictionary(language) {
  return dictionaries[language] || dictionaries[DEFAULT_LANGUAGE];
}

export function getByPath(object, path) {
  return path.split('.').reduce((current, key) => {
    if (current == null) {
      return undefined;
    }
    return current[key];
  }, object);
}
